import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import palette from 'theme/palette';
import './styles.css';

export default function Preloader({ isGray, spinnerSize = 15, compact }) {
  var color = isGray ? palette.fieldHint : palette.brandOrange;

  var classNames = [
    'preloader',
    isGray && 'preloader--gray',
    compact && 'preloader--compact',
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames}>
      <BeatLoader color={color} size={spinnerSize} />
    </div>
  );
}
